import { MetricType } from "web-vitals";

export function reportWebVitals(onPerfEntry?: (metric: MetricType) => void)
{
    if (onPerfEntry && onPerfEntry instanceof Function)
    {
        import("web-vitals").then(function(module)
        {
            module.onCLS(onPerfEntry);
            module.onINP(onPerfEntry);
            module.onFCP(onPerfEntry);
            module.onLCP(onPerfEntry);
            module.onTTFB(onPerfEntry);
        });
    }
};